import styled, { css } from 'styled-components'
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu'

export const StyledSizeSelector = styled.div`
  position: relative;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.border};
  user-select: none;
  background-color: ${({ theme }) => theme.colors.background};
`

export const StyledTrigger = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 1.3rem 1.5rem;
  background-color: inherit;
  border: none;
  cursor: pointer;
  height: 4.3rem;

  span {
    font-size: 1.4rem;
  }

  svg {
    transition: transform 0.3s ease;
    transform: rotate(90deg);
  }

  &[data-state='open'] svg {
    transform: rotate(-90deg);
  }
`

export const StyledContent = styled(DropdownMenuPrimitive.Content)`
  z-index: 10;
  background-color: ${({ theme }) => theme.colors.background};
  border: 1px solid ${({ theme }) => theme.colors.border};
  overflow-y: auto;
  width: calc(var(--radix-dropdown-menu-trigger-width) + 2px);
  max-height: 17rem;
  margin: 0 0 0 -1px;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: #d9d9d9;
  }

  &::-webkit-scrollbar-thumb {
    background: #313332;
  }
`

export const StyledItem = styled(DropdownMenuPrimitive.RadioItem)<{
  $isOutOfStock: boolean
}>`
  padding: 12px 15px;
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  gap: 1.5rem;
  align-items: center;
  transition: background-color 0.1s linear;

  &:hover,
  &[data-highlighted] {
    background-color: #d9d9d9;
  }

  &[data-state='checked'] {
    background-color: rgba(49, 51, 50, 0.08);
  }

  ${(props) =>
    props.$isOutOfStock &&
    css`
      color: ${({ theme }) => theme.colors.text.light};
    `}
`
